export default __webpack_public_path__ + "static/media/align_horizontal_center.82d9da9c.svg";